import React, {FC, useContext, useState} from "react";

import { UserContext } from "features/account";
import Button from "shared/ui/Button";
import {Button_Style, Button_Type} from "shared/ui/Button/Button";
import { ReactComponent as IconBack } from "assets/img/icons/icon_arrow-Right.svg";

import VideoFrame from "shared/ui/VideoFrame";
import Checkbox from "shared/ui/Checkbox";

type IDPayOverviewProps = {
    showOverview: boolean;
    setShowOverview: any;
};


const IDPayOverview: FC<IDPayOverviewProps> = ({
      showOverview = true,
      setShowOverview,
}) => {
    const { userType } = useContext(UserContext);

    const [selectedNeverShowAgain, setSelectedNeverShowAgain] = useState(false);

    const handleStartDashBoard = () => {
        setShowOverview(false);
        localStorage.setItem("IDPayOverview", JSON.stringify(!selectedNeverShowAgain));
    };

    const checkSelect = () => {
        const newSelect = !selectedNeverShowAgain;
        setSelectedNeverShowAgain(newSelect);
    };

    return (
        <>
            <div className="IDPayOverview">
                <div className="content__body">
                    <div className="row flex-wrap">
                        <div className={`col-sm-5`}>
                            <div className="content--card-2 relative h-100 mb-2 d-flex flex-column justify-content-between">
                                <div className="mb-2 text-secondary">
                                    Un moyen sécurisé, conçu pour se proteger contre les arnaques dans les transferts d’argent.
                                    <ul className="mt-1">
                                        Envoyer votre argent tout en vous garantissant de l’identité du beneficaire
                                    </ul>

                                </div>
                                <div className="d-flex flex-column justify-content-between align-items-center">
                                    <Checkbox
                                        label="Ne plus afficher cette page"
                                        onChange={checkSelect}
                                        checked={selectedNeverShowAgain}
                                    />
                                    <Button
                                        type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                                        label="EFFECTUER VOTRE PAIEMENT"
                                        style={Button_Style.SOLID}
                                        onClick={() => handleStartDashBoard()}
                                        icon={<IconBack
                                            className="PageHeader__icon"
                                            fill={"#9FC1EF"}
                                        />}
                                    />
                                </div>

                            </div>
                        </div>
                        <div className="col-sm-7">
                            <div className="mt-3">
                                <VideoFrame
                                    url="https://www.youtube.com/watch?v=XvoHvSI-Huo&t=7s"
                                >
                                    <span className="text-primary bold">La plateforme ID Protect</span>
                                </VideoFrame>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};
export default IDPayOverview;